module.exports = __webpack_public_path__ + "static/img/10.3a1a37c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/10/sp/10.png
// module id = lJdh
// module chunks = 0